import { useNavigate } from 'react-router';
import {
  Button,
  Icon,
  IconType,
  Loader,
  QueryBoundary,
  Size,
} from '@outdoria/ui';
import { ActionBar, Table, TableHeader } from '../../containers';
import {
  useAdminDeleteGatheringSpotType,
  useGetGatheringSpotTypesAll,
} from '@outdoria/api';
import { GatheringSpotType } from '@outdoria/types';

import s from './GatheringSpotTypesView.module.scss';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const GatheringSpotTypesView = () => (
  <QueryBoundary fallback={<Loader />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  const navigate = useNavigate();

  const { data: gatheringSpotTypes } = useGetGatheringSpotTypesAll();
  const { tableHeaders, tableRows } = useTable(gatheringSpotTypes);

  const onGatheringSpotTypeCreate = () => {
    navigate('create');
  };

  return (
    <div className={s.view}>
      <ActionBar
        buttons={
          <Button
            label="Create new gathering spot type"
            onClick={onGatheringSpotTypeCreate}
          />
        }
      />

      <Table tableHeaders={tableHeaders} items={tableRows} />
    </div>
  );
};

const useTable = (gatheringSpotTypes: GatheringSpotType[]) => {
  const tableHeaders: TableHeader<GatheringSpotType>[] = [
    { id: 'name', label: 'Name' },
    { id: 'description', label: 'Description' },
    { id: 'actions', label: 'Actions' },
  ];

  const tableRows = gatheringSpotTypes.map(
    (gatheringSpotType: GatheringSpotType) => [
      <Table.Cell
        content={
          <>
            <Icon icon={gatheringSpotType.icon as IconType} />
            <span>{gatheringSpotType.name}</span>
          </>
        }
      />,
      <Table.Cell content={gatheringSpotType.description} />,
      <Table.Cell
        content={<Actions id={gatheringSpotType.gathering_spot_type_id} />}
      />,
    ],
  );

  return { tableHeaders, tableRows };
};

const Actions = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  const { mutate, error, isSuccess } = useAdminDeleteGatheringSpotType();

  useEffect(() => {
    if (isSuccess) toast.success('Yay! Deleted :3');
  }, [isSuccess]);

  useEffect(() => {
    if (error) toast.error(error.message);
  }, [error]);

  const onDelete = () => {
    const shouldDelete = confirm(
      'Do you really want to delete this gathering spot type?',
    );
    if (shouldDelete) mutate(id);
  };

  return (
    <>
      <Button
        label={<Icon icon="Edit" size={Size.MICRO} />}
        onClick={() => navigate(id)}
        style={{ width: '40px' }}
      />
      <Button
        label={<Icon icon="Trash" size={Size.MICRO} />}
        onClick={onDelete}
        variant={Button.Variant.DANGER}
        style={{ width: '40px' }}
      />
    </>
  );
};
